module.exports = ".entity-filter input[type=\"text\"]::-webkit-input-placeholder{\r\n    font-size: 15px !important;\r\n}\r\n.entity-filter input[type=\"text\"]::-moz-placeholder{\r\n    font-size: 15px !important;\r\n}\r\n.entity-filter input[type=\"text\"]::-ms-input-placeholder{\r\n    font-size: 15px !important;\r\n}\r\n.entity-filter input[type=\"text\"]::placeholder{\r\n    font-size: 15px !important;\r\n}\r\nh1{\r\n    color: #e60000;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/stubs-overview/stubs-overview.component.css
// module id = ./src/app/stubs-overview/stubs-overview.component.css
// module chunks = main